import '../../utils/assertions.es.js';
import { maestroComponent } from '../../utils/componentHelpers.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'react';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { StyledNotification } from './styled.es.js';

const Notification = maestroComponent("Notification", StyledNotification);
Notification.defaultProps = {
  variant: "success",
  kind: "temporary"
};

export { Notification };
//# sourceMappingURL=Notification.es.js.map
